import { get } from 'lodash';
import { LAYOUT_PG_TEXT_ON_IMAGE_SMALL, LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM, LAYOUT_PG_TEXT_ON_IMAGE_LARGE, LAYOUT_PG_CARD_MEDIUM, LAYOUT_PG_SIDE_BY_SIDE, LAYOUT_PG_SIDE_BY_SIDE_RIGHT, LAYOUT_PG_GRID, LAYOUT_PG_ONE_COLUMN, LAYOUT_LIST, LAYOUT_LIST_MEDIUM, LAYOUT_LIST_LARGE, LAYOUT_SLIDER, LAYOUT_PG_GRID_INTERMEDIATE, LAYOUT_PG_GRID_LARGE, } from './layout-types';
import { SECTION_HOMEPAGE, SECTION_CATEGORY, SECTION_MY_POSTS, SECTION_POST_LIST, SECTION_RELATED_POSTS, } from './sections';
export const PG_LAYOUT_IMAGE_RATIO_OPTIONS = {
    RATIO_16ON9: 1,
    RATIO_4ON3: 2,
    SQUARE: 3,
    RATIO_3ON4: 4,
    RATIO_9ON16: 5,
    RATIO_16ON7: 6, // hidden setting - used for old layouts to pro gallery migration
};
export const PG_LAYOUT_IMAGE_RATIOS_BY_ID = {
    1: 'RATIO_16ON9',
    2: 'RATIO_4ON3',
    3: 'SQUARE',
    4: 'RATIO_3ON4',
    5: 'RATIO_9ON16',
    6: 'RATIO_16ON7',
};
export const PG_LAYOUT_IMAGE_ALIGNMENT_OPTIONS = {
    RIGHT_ALIGN: 1,
    LEFT_ALIGN: 2,
};
export const PG_LAYOUT_IMAGE_CROP_TYPE_OPTIONS = {
    CROP: '0',
    MAX: '1',
};
export const PG_LAYOUT_IMAGE_RESIZING_MODE_OPTIONS = {
    PROPORTIONAL: 0,
    FIXED: 1,
};
export const PG_LAYOUT_INFO_SIZE_TYPE_OPTIONS = {
    MANUAL: 0,
    AUTO: 1,
};
export const PG_LAYOUT_CARDS_ROW_TYPE_OPTIONS = {
    FIT_TO_SCREEN: 0,
    ITEMS_PER_ROW: 1,
};
export const DEFAULT_PG_LAYOUT_IMAGE_RATIO = 'DEFAULT_PG_LAYOUT_IMAGE_RATIO';
export const DEFAULT_PG_LAYOUT_ITEM_SIZE = 'DEFAULT_PG_LAYOUT_ITEM_SIZE';
export const DEFAULT_PG_LAYOUT_CARDS_ROW_TYPE = 'DEFAULT_PG_LAYOUT_CARDS_ROW_TYPE';
export const DEFAULT_PG_LAYOUT_POSTS_PER_ROW = 'DEFAULT_PG_LAYOUT_POSTS_PER_ROW';
export const DEFAULT_PG_LAYOUT_INFO_SIZE = 'DEFAULT_PG_LAYOUT_INFO_SIZE';
export const DEFAULT_PG_LAYOUT_INFO_SIZE_TYPE = 'DEFAULT_PG_LAYOUT_INFO_SIZE_TYPE';
export const DEFAULT_PG_LAYOUT_SPACING = 'DEFAULT_PG_LAYOUT_SPACING';
export const DEFAULT_PG_LAYOUT_SIDES_PADDING = 'DEFAULT_PG_LAYOUT_SIDES_PADDING';
export const DEFAULT_PG_LAYOUT_MARGINS = 'DEFAULT_PG_LAYOUT_MARGINS';
export const DEFAULT_PG_IMAGE_ALIGNMENT = 'DEFAULT_PG_IMAGE_ALIGNMENT';
export const DEFAULT_PG_IMAGE_PROPORTIONS = 'DEFAULT_PG_IMAGE_PROPORTIONS';
export const DEFAULT_PG_IMAGE_WIDTH = 'DEFAULT_PG_IMAGE_WIDTH';
export const DEFAULT_PG_IMAGE_RESIZING_MODE = 'DEFAULT_PG_IMAGE_RESIZING_MODE';
export const DEFAULT_PG_LAYOUT_IMAGE_CROP_TYPE = 'DEFAULT_PG_LAYOUT_IMAGE_CROP_TYPE';
export const DEFAULT_PG_LAYOUT_TITLE_LINE_COUNT = 'DEFAULT_PG_LAYOUT_TITLE_LINE_COUNT';
export const DEFAULT_PG_LAYOUT_DESCRIPTION_LINE_COUNT = 'DEFAULT_PG_LAYOUT_DESCRIPTION_LINE_COUNT';
export const MIN_PG_LAYOUT_SPACNG = 'MIN_PG_LAYOUT_SPACNG';
export const MIN_PG_LAYOUT_ITEM_SIZE = 'MIN_PG_LAYOUT_ITEM_SIZE';
export const MIN_PG_LAYOUT_POSTS_PER_ROW = 'MIN_PG_LAYOUT_POSTS_PER_ROW';
export const MIN_PG_LAYOUT_INFO_SIZE = 'MIN_PG_LAYOUT_INFO_SIZE';
export const MIN_PG_LAYOUT_SIDES_PADDING = 'MIN_PG_LAYOUT_SIDES_PADDING';
export const MIN_PG_LAYOUT_MARGINS = 'MIN_PG_LAYOUT_MARGINS';
export const MIN_PG_LAYOUT_TITLE_LINE_COUNT = 'MIN_PG_LAYOUT_TITLE_LINE_COUNT';
export const MIN_PG_LAYOUT_DESCRIPTION_LINE_COUNT = 'MIN_PG_LAYOUT_DESCRIPTION_LINE_COUNT';
export const MIN_PG_IMAGE_ALIGNMENT = 'MIN_PG_IMAGE_ALIGNMENT';
export const MIN_PG_IMAGE_PROPORTIONS = 'MIN_PG_IMAGE_PROPORTIONS';
export const MAX_PG_LAYOUT_ITEM_SIZE = 'MAX_PG_LAYOUT_ITEM_SIZE';
export const MAX_PG_LAYOUT_POSTS_PER_ROW = 'MAX_PG_LAYOUT_POSTS_PER_ROW';
export const MAX_PG_LAYOUT_INFO_SIZE = 'MAX_PG_LAYOUT_INFO_SIZE';
export const MAX_PG_LAYOUT_SPACNG = 'MAX_PG_LAYOUT_SPACNG';
export const MAX_PG_LAYOUT_SIDES_PADDING = 'MAX_PG_LAYOUT_SIDES_PADDING';
export const MAX_PG_LAYOUT_MARGINS = 'MAX_PG_LAYOUT_MARGINS';
export const MAX_PG_LAYOUT_TITLE_LINE_COUNT = 'MAX_PG_LAYOUT_TITLE_LINE_COUNT';
export const MAX_PG_LAYOUT_DESCRIPTION_LINE_COUNT = 'MAX_PG_LAYOUT_DESCRIPTION_LINE_COUNT';
export const MAX_PG_IMAGE_ALIGNMENT = 'MAX_PG_IMAGE_ALIGNMENT';
export const MAX_PG_IMAGE_PROPORTIONS = 'MAX_PG_IMAGE_PROPORTIONS';
export const DEFAULT_PG_LAYOUT_SPACING_MOBILE = 'DEFAULT_PG_LAYOUT_SPACING_MOBILE';
export const DEFAULT_PG_LAYOUT_MARGINS_MOBILE = 'DEFAULT_PG_LAYOUT_MARGINS_MOBILE';
export const DEFAULT_PG_LAYOUT_IMAGE_RATIO_MOBILE = 'DEFAULT_PG_LAYOUT_IMAGE_RATIO_MOBILE';
const PG_TEXT_ON_IMAGE_MEDIUM_SETTINGS = {
    [MIN_PG_LAYOUT_SPACNG]: 0,
    [MIN_PG_LAYOUT_ITEM_SIZE]: 150,
    [MIN_PG_LAYOUT_POSTS_PER_ROW]: 1,
    [MIN_PG_LAYOUT_SIDES_PADDING]: 0,
    [MIN_PG_LAYOUT_MARGINS]: 0,
    [MIN_PG_LAYOUT_TITLE_LINE_COUNT]: 1,
    [MAX_PG_LAYOUT_SPACNG]: 100,
    [MAX_PG_LAYOUT_ITEM_SIZE]: 1000,
    [MAX_PG_LAYOUT_POSTS_PER_ROW]: 5,
    [MAX_PG_LAYOUT_SIDES_PADDING]: 100,
    [MAX_PG_LAYOUT_MARGINS]: 100,
    [MAX_PG_LAYOUT_TITLE_LINE_COUNT]: 6,
    [DEFAULT_PG_LAYOUT_IMAGE_RATIO]: 3,
    [DEFAULT_PG_LAYOUT_ITEM_SIZE]: 454,
    [DEFAULT_PG_LAYOUT_CARDS_ROW_TYPE]: PG_LAYOUT_CARDS_ROW_TYPE_OPTIONS.FIT_TO_SCREEN,
    [DEFAULT_PG_LAYOUT_POSTS_PER_ROW]: 3,
    [DEFAULT_PG_LAYOUT_SPACING]: 32,
    [DEFAULT_PG_LAYOUT_SIDES_PADDING]: 30,
    [DEFAULT_PG_LAYOUT_MARGINS]: 20,
    [DEFAULT_PG_LAYOUT_IMAGE_CROP_TYPE]: 0,
    [DEFAULT_PG_LAYOUT_TITLE_LINE_COUNT]: 3,
    [DEFAULT_PG_LAYOUT_SPACING_MOBILE]: 20,
    [DEFAULT_PG_LAYOUT_MARGINS_MOBILE]: 0,
    [DEFAULT_PG_LAYOUT_IMAGE_RATIO_MOBILE]: 3,
};
const PG_TEXT_ON_IMAGE_SMALL_SETTINGS = Object.assign(Object.assign({}, PG_TEXT_ON_IMAGE_MEDIUM_SETTINGS), { [DEFAULT_PG_LAYOUT_ITEM_SIZE]: 292, [DEFAULT_PG_LAYOUT_SIDES_PADDING]: 24 });
const PG_TEXT_ON_IMAGE_LARGE_SETTINGS = Object.assign(Object.assign({}, PG_TEXT_ON_IMAGE_MEDIUM_SETTINGS), { [DEFAULT_PG_LAYOUT_IMAGE_RATIO]: 1, [DEFAULT_PG_LAYOUT_ITEM_SIZE]: 1000 });
const PG_CARD_MEDIUM_SETTINGS = {
    [MIN_PG_LAYOUT_SPACNG]: 0,
    [MIN_PG_LAYOUT_ITEM_SIZE]: 150,
    [MIN_PG_LAYOUT_POSTS_PER_ROW]: 1,
    [MIN_PG_LAYOUT_INFO_SIZE]: 0,
    [MIN_PG_LAYOUT_SIDES_PADDING]: 0,
    [MIN_PG_LAYOUT_MARGINS]: 0,
    [MIN_PG_LAYOUT_TITLE_LINE_COUNT]: 1,
    [MIN_PG_LAYOUT_DESCRIPTION_LINE_COUNT]: 1,
    [MAX_PG_LAYOUT_SPACNG]: 100,
    [MAX_PG_LAYOUT_ITEM_SIZE]: 1000,
    [MAX_PG_LAYOUT_POSTS_PER_ROW]: 5,
    [MAX_PG_LAYOUT_INFO_SIZE]: 700,
    [MAX_PG_LAYOUT_SIDES_PADDING]: 100,
    [MAX_PG_LAYOUT_MARGINS]: 100,
    [MAX_PG_LAYOUT_TITLE_LINE_COUNT]: 6,
    [MAX_PG_LAYOUT_DESCRIPTION_LINE_COUNT]: 8,
    [DEFAULT_PG_LAYOUT_ITEM_SIZE]: 454,
    [DEFAULT_PG_LAYOUT_CARDS_ROW_TYPE]: PG_LAYOUT_CARDS_ROW_TYPE_OPTIONS.FIT_TO_SCREEN,
    [DEFAULT_PG_LAYOUT_POSTS_PER_ROW]: 3,
    [DEFAULT_PG_LAYOUT_INFO_SIZE]: 350,
    [DEFAULT_PG_LAYOUT_INFO_SIZE_TYPE]: PG_LAYOUT_INFO_SIZE_TYPE_OPTIONS.MANUAL,
    [DEFAULT_PG_LAYOUT_SPACING]: 32,
    [DEFAULT_PG_LAYOUT_SIDES_PADDING]: 30,
    [DEFAULT_PG_LAYOUT_MARGINS]: 20,
    [DEFAULT_PG_LAYOUT_TITLE_LINE_COUNT]: 3,
    [DEFAULT_PG_LAYOUT_DESCRIPTION_LINE_COUNT]: 3,
};
const PG_SIDE_BY_SIDE_SETTINGS = {
    [MIN_PG_LAYOUT_ITEM_SIZE]: 450,
    [MIN_PG_LAYOUT_SPACNG]: 0,
    [MIN_PG_LAYOUT_SIDES_PADDING]: 0,
    [MIN_PG_LAYOUT_MARGINS]: 0,
    [MIN_PG_IMAGE_PROPORTIONS]: 20,
    [MIN_PG_LAYOUT_TITLE_LINE_COUNT]: 1,
    [MIN_PG_LAYOUT_DESCRIPTION_LINE_COUNT]: 1,
    [MAX_PG_LAYOUT_ITEM_SIZE]: 1200,
    [MAX_PG_LAYOUT_SPACNG]: 100,
    [MAX_PG_LAYOUT_SIDES_PADDING]: 100,
    [MAX_PG_LAYOUT_MARGINS]: 100,
    [MAX_PG_IMAGE_PROPORTIONS]: 60,
    [MAX_PG_LAYOUT_TITLE_LINE_COUNT]: 6,
    [MAX_PG_LAYOUT_DESCRIPTION_LINE_COUNT]: 8,
    [DEFAULT_PG_LAYOUT_ITEM_SIZE]: 1100,
    [DEFAULT_PG_LAYOUT_SPACING]: 32,
    [DEFAULT_PG_LAYOUT_SIDES_PADDING]: 36,
    [DEFAULT_PG_LAYOUT_MARGINS]: 20,
    [DEFAULT_PG_IMAGE_PROPORTIONS]: 50,
    [DEFAULT_PG_IMAGE_RESIZING_MODE]: PG_LAYOUT_IMAGE_RESIZING_MODE_OPTIONS.PROPORTIONAL,
    [DEFAULT_PG_IMAGE_ALIGNMENT]: 2,
    [DEFAULT_PG_LAYOUT_IMAGE_RATIO]: 2,
    [DEFAULT_PG_LAYOUT_IMAGE_CROP_TYPE]: 0,
    [DEFAULT_PG_LAYOUT_TITLE_LINE_COUNT]: 3,
    [DEFAULT_PG_LAYOUT_DESCRIPTION_LINE_COUNT]: 3,
};
const PG_SIDE_BY_SIDE_RIGHT_SETTINGS = Object.assign(Object.assign({}, PG_SIDE_BY_SIDE_SETTINGS), { [DEFAULT_PG_IMAGE_ALIGNMENT]: 1 });
const PG_SIDE_BY_SIDE_MY_POSTS_SETTINGS = {
    [DEFAULT_PG_LAYOUT_ITEM_SIZE]: 980,
    [DEFAULT_PG_LAYOUT_SPACING]: 24,
    [DEFAULT_PG_LAYOUT_SIDES_PADDING]: 30,
    [DEFAULT_PG_LAYOUT_MARGINS]: 30,
    [DEFAULT_PG_IMAGE_WIDTH]: 177,
    [DEFAULT_PG_IMAGE_RESIZING_MODE]: PG_LAYOUT_IMAGE_RESIZING_MODE_OPTIONS.FIXED,
    [DEFAULT_PG_IMAGE_ALIGNMENT]: 2,
    [DEFAULT_PG_LAYOUT_IMAGE_RATIO]: 3,
    [DEFAULT_PG_LAYOUT_IMAGE_CROP_TYPE]: 0,
    [DEFAULT_PG_LAYOUT_TITLE_LINE_COUNT]: 2,
    [DEFAULT_PG_LAYOUT_DESCRIPTION_LINE_COUNT]: 0,
};
const PG_SIDE_BY_SIDE_RELATED_POSTS_SETTINGS = {
    [MIN_PG_LAYOUT_ITEM_SIZE]: 450,
    [MIN_PG_LAYOUT_SPACNG]: 0,
    [MIN_PG_LAYOUT_SIDES_PADDING]: 0,
    [MIN_PG_LAYOUT_MARGINS]: 0,
    [MIN_PG_IMAGE_PROPORTIONS]: 20,
    [MIN_PG_LAYOUT_TITLE_LINE_COUNT]: 1,
    [MIN_PG_LAYOUT_DESCRIPTION_LINE_COUNT]: 1,
    [MAX_PG_LAYOUT_ITEM_SIZE]: 1200,
    [MAX_PG_LAYOUT_SPACNG]: 100,
    [MAX_PG_LAYOUT_SIDES_PADDING]: 100,
    [MAX_PG_LAYOUT_MARGINS]: 100,
    [MAX_PG_IMAGE_PROPORTIONS]: 60,
    [MAX_PG_LAYOUT_TITLE_LINE_COUNT]: 6,
    [MAX_PG_LAYOUT_DESCRIPTION_LINE_COUNT]: 8,
    [DEFAULT_PG_LAYOUT_ITEM_SIZE]: 1100,
    [DEFAULT_PG_LAYOUT_SPACING]: 24,
    [DEFAULT_PG_LAYOUT_SIDES_PADDING]: 20,
    [DEFAULT_PG_LAYOUT_MARGINS]: 20,
    [DEFAULT_PG_IMAGE_PROPORTIONS]: 50,
    [DEFAULT_PG_IMAGE_RESIZING_MODE]: PG_LAYOUT_IMAGE_RESIZING_MODE_OPTIONS.PROPORTIONAL,
    [DEFAULT_PG_IMAGE_ALIGNMENT]: PG_LAYOUT_IMAGE_ALIGNMENT_OPTIONS.RIGHT_ALIGN,
    [DEFAULT_PG_LAYOUT_IMAGE_RATIO]: PG_LAYOUT_IMAGE_RATIO_OPTIONS.SQUARE,
    [DEFAULT_PG_LAYOUT_IMAGE_CROP_TYPE]: PG_LAYOUT_IMAGE_CROP_TYPE_OPTIONS.CROP,
    [DEFAULT_PG_LAYOUT_TITLE_LINE_COUNT]: 3,
    [DEFAULT_PG_LAYOUT_DESCRIPTION_LINE_COUNT]: 3,
};
const PG_GRID_SETTINGS = {
    [MIN_PG_LAYOUT_SPACNG]: 0,
    [MIN_PG_LAYOUT_ITEM_SIZE]: 150,
    [MIN_PG_LAYOUT_POSTS_PER_ROW]: 1,
    [MIN_PG_LAYOUT_INFO_SIZE]: 0,
    [MIN_PG_LAYOUT_SIDES_PADDING]: 0,
    [MIN_PG_LAYOUT_MARGINS]: 0,
    [MIN_PG_LAYOUT_TITLE_LINE_COUNT]: 1,
    [MIN_PG_LAYOUT_DESCRIPTION_LINE_COUNT]: 1,
    [MAX_PG_LAYOUT_SPACNG]: 100,
    [MAX_PG_LAYOUT_ITEM_SIZE]: 1000,
    [MAX_PG_LAYOUT_POSTS_PER_ROW]: 5,
    [MAX_PG_LAYOUT_INFO_SIZE]: 700,
    [MAX_PG_LAYOUT_SIDES_PADDING]: 100,
    [MAX_PG_LAYOUT_MARGINS]: 100,
    [MAX_PG_LAYOUT_TITLE_LINE_COUNT]: 6,
    [MAX_PG_LAYOUT_DESCRIPTION_LINE_COUNT]: 8,
    [DEFAULT_PG_LAYOUT_IMAGE_RATIO]: 2,
    [DEFAULT_PG_LAYOUT_ITEM_SIZE]: 292,
    [DEFAULT_PG_LAYOUT_CARDS_ROW_TYPE]: PG_LAYOUT_CARDS_ROW_TYPE_OPTIONS.FIT_TO_SCREEN,
    [DEFAULT_PG_LAYOUT_POSTS_PER_ROW]: 3,
    [DEFAULT_PG_LAYOUT_INFO_SIZE]: 350,
    [DEFAULT_PG_LAYOUT_INFO_SIZE_TYPE]: PG_LAYOUT_INFO_SIZE_TYPE_OPTIONS.MANUAL,
    [DEFAULT_PG_LAYOUT_SPACING]: 32,
    [DEFAULT_PG_LAYOUT_SIDES_PADDING]: 24,
    [DEFAULT_PG_LAYOUT_MARGINS]: 20,
    [DEFAULT_PG_LAYOUT_IMAGE_CROP_TYPE]: 0,
    [DEFAULT_PG_LAYOUT_TITLE_LINE_COUNT]: 3,
    [DEFAULT_PG_LAYOUT_DESCRIPTION_LINE_COUNT]: 3,
    [DEFAULT_PG_LAYOUT_SPACING_MOBILE]: 20,
    [DEFAULT_PG_LAYOUT_MARGINS_MOBILE]: 0,
    [DEFAULT_PG_LAYOUT_IMAGE_RATIO_MOBILE]: 2,
};
const PG_GRID_RELATED_POSTS_SETTINGS = {
    [MIN_PG_LAYOUT_SPACNG]: 0,
    [MIN_PG_LAYOUT_ITEM_SIZE]: 150,
    [MIN_PG_LAYOUT_POSTS_PER_ROW]: 1,
    [MIN_PG_LAYOUT_INFO_SIZE]: 0,
    [MIN_PG_LAYOUT_SIDES_PADDING]: 0,
    [MIN_PG_LAYOUT_MARGINS]: 0,
    [MIN_PG_LAYOUT_TITLE_LINE_COUNT]: 1,
    [MIN_PG_LAYOUT_DESCRIPTION_LINE_COUNT]: 1,
    [MAX_PG_LAYOUT_SPACNG]: 100,
    [MAX_PG_LAYOUT_ITEM_SIZE]: 1000,
    [MAX_PG_LAYOUT_POSTS_PER_ROW]: 5,
    [MAX_PG_LAYOUT_INFO_SIZE]: 700,
    [MAX_PG_LAYOUT_SIDES_PADDING]: 100,
    [MAX_PG_LAYOUT_MARGINS]: 100,
    [MAX_PG_LAYOUT_TITLE_LINE_COUNT]: 6,
    [MAX_PG_LAYOUT_DESCRIPTION_LINE_COUNT]: 8,
    [DEFAULT_PG_LAYOUT_IMAGE_RATIO]: PG_LAYOUT_IMAGE_RATIO_OPTIONS.RATIO_4ON3,
    [DEFAULT_PG_LAYOUT_ITEM_SIZE]: 292,
    [DEFAULT_PG_LAYOUT_CARDS_ROW_TYPE]: PG_LAYOUT_CARDS_ROW_TYPE_OPTIONS.ITEMS_PER_ROW,
    [DEFAULT_PG_LAYOUT_POSTS_PER_ROW]: 3,
    [DEFAULT_PG_LAYOUT_INFO_SIZE]: 350,
    [DEFAULT_PG_LAYOUT_INFO_SIZE_TYPE]: PG_LAYOUT_INFO_SIZE_TYPE_OPTIONS.AUTO,
    [DEFAULT_PG_LAYOUT_SPACING]: 24,
    [DEFAULT_PG_LAYOUT_SIDES_PADDING]: 20,
    [DEFAULT_PG_LAYOUT_MARGINS]: 0,
    [DEFAULT_PG_LAYOUT_IMAGE_CROP_TYPE]: PG_LAYOUT_IMAGE_CROP_TYPE_OPTIONS.CROP,
    [DEFAULT_PG_LAYOUT_TITLE_LINE_COUNT]: 3,
    [DEFAULT_PG_LAYOUT_DESCRIPTION_LINE_COUNT]: 3,
    [DEFAULT_PG_LAYOUT_SPACING_MOBILE]: 20,
    [DEFAULT_PG_LAYOUT_MARGINS_MOBILE]: 0,
    [DEFAULT_PG_LAYOUT_IMAGE_RATIO_MOBILE]: 2,
};
const PG_GRID_INTERMEDIATE_SETTINGS = Object.assign(Object.assign({}, PG_GRID_SETTINGS), { [DEFAULT_PG_LAYOUT_ITEM_SIZE]: 454 });
const PG_GRID_LARGE_SETTINGS = Object.assign(Object.assign({}, PG_GRID_SETTINGS), { [DEFAULT_PG_LAYOUT_IMAGE_RATIO]: 1, [DEFAULT_PG_LAYOUT_ITEM_SIZE]: 1000 });
const PG_ONE_COLUMN_SETTINGS = {
    [MIN_PG_LAYOUT_SPACNG]: 0,
    [MIN_PG_LAYOUT_SIDES_PADDING]: 0,
    [MIN_PG_LAYOUT_MARGINS]: 0,
    [MIN_PG_LAYOUT_INFO_SIZE]: 0,
    [MIN_PG_LAYOUT_TITLE_LINE_COUNT]: 1,
    [MIN_PG_LAYOUT_DESCRIPTION_LINE_COUNT]: 1,
    [MAX_PG_LAYOUT_SPACNG]: 100,
    [MAX_PG_LAYOUT_SIDES_PADDING]: 100,
    [MAX_PG_LAYOUT_MARGINS]: 100,
    [MAX_PG_LAYOUT_INFO_SIZE]: 700,
    [MAX_PG_LAYOUT_TITLE_LINE_COUNT]: 6,
    [MAX_PG_LAYOUT_DESCRIPTION_LINE_COUNT]: 8,
    [DEFAULT_PG_LAYOUT_SPACING]: 32,
    [DEFAULT_PG_LAYOUT_SIDES_PADDING]: 48,
    [DEFAULT_PG_LAYOUT_MARGINS]: 20,
    [DEFAULT_PG_LAYOUT_IMAGE_RATIO]: 6,
    [DEFAULT_PG_LAYOUT_INFO_SIZE]: 350,
    [DEFAULT_PG_LAYOUT_INFO_SIZE_TYPE]: PG_LAYOUT_INFO_SIZE_TYPE_OPTIONS.MANUAL,
    [DEFAULT_PG_LAYOUT_TITLE_LINE_COUNT]: 3,
    [DEFAULT_PG_LAYOUT_DESCRIPTION_LINE_COUNT]: 3,
};
const PG_LIST_SETTINGS = {
    [MIN_PG_LAYOUT_SPACNG]: 0,
    [MIN_PG_LAYOUT_ITEM_SIZE]: 150,
    [MIN_PG_LAYOUT_POSTS_PER_ROW]: 1,
    [MIN_PG_LAYOUT_SIDES_PADDING]: 0,
    [MIN_PG_LAYOUT_MARGINS]: 0,
    [MIN_PG_LAYOUT_INFO_SIZE]: 0,
    [MIN_PG_IMAGE_PROPORTIONS]: 20,
    [MIN_PG_LAYOUT_TITLE_LINE_COUNT]: 1,
    [MIN_PG_LAYOUT_DESCRIPTION_LINE_COUNT]: 1,
    [MAX_PG_LAYOUT_SPACNG]: 100,
    [MAX_PG_LAYOUT_ITEM_SIZE]: 1000,
    [MAX_PG_LAYOUT_POSTS_PER_ROW]: 5,
    [MAX_PG_LAYOUT_SIDES_PADDING]: 100,
    [MAX_PG_LAYOUT_MARGINS]: 100,
    [MAX_PG_LAYOUT_INFO_SIZE]: 300,
    [MAX_PG_IMAGE_PROPORTIONS]: 80,
    [MAX_PG_LAYOUT_TITLE_LINE_COUNT]: 6,
    [MAX_PG_LAYOUT_DESCRIPTION_LINE_COUNT]: 8,
    [DEFAULT_PG_LAYOUT_SPACING]: 12,
    [DEFAULT_PG_LAYOUT_ITEM_SIZE]: 292,
    [DEFAULT_PG_LAYOUT_CARDS_ROW_TYPE]: PG_LAYOUT_CARDS_ROW_TYPE_OPTIONS.FIT_TO_SCREEN,
    [DEFAULT_PG_LAYOUT_POSTS_PER_ROW]: 3,
    [DEFAULT_PG_LAYOUT_INFO_SIZE]: 100,
    [DEFAULT_PG_LAYOUT_SIDES_PADDING]: 12,
    [DEFAULT_PG_LAYOUT_MARGINS]: 0,
    [DEFAULT_PG_LAYOUT_IMAGE_RATIO]: 3,
    [DEFAULT_PG_IMAGE_PROPORTIONS]: 25,
    [DEFAULT_PG_IMAGE_RESIZING_MODE]: PG_LAYOUT_IMAGE_RESIZING_MODE_OPTIONS.PROPORTIONAL,
    [DEFAULT_PG_IMAGE_ALIGNMENT]: 1,
    [DEFAULT_PG_LAYOUT_IMAGE_CROP_TYPE]: 0,
    [DEFAULT_PG_LAYOUT_TITLE_LINE_COUNT]: 3,
    [DEFAULT_PG_LAYOUT_DESCRIPTION_LINE_COUNT]: 3,
    [DEFAULT_PG_LAYOUT_SPACING_MOBILE]: 20,
    [DEFAULT_PG_LAYOUT_MARGINS_MOBILE]: 0,
    [DEFAULT_PG_LAYOUT_IMAGE_RATIO_MOBILE]: 3,
};
const PG_LIST_MEDIUM_SETTINGS = Object.assign(Object.assign({}, PG_LIST_SETTINGS), { [DEFAULT_PG_LAYOUT_ITEM_SIZE]: 454, [DEFAULT_PG_LAYOUT_INFO_SIZE]: 60, [DEFAULT_PG_LAYOUT_MARGINS]: 20, [DEFAULT_PG_LAYOUT_SPACING]: 24, [DEFAULT_PG_IMAGE_ALIGNMENT]: 2, [DEFAULT_PG_LAYOUT_SIDES_PADDING]: 24 });
const PG_LIST_LARGE_SETTINGS = Object.assign(Object.assign({}, PG_LIST_SETTINGS), { [DEFAULT_PG_LAYOUT_ITEM_SIZE]: 1000, [DEFAULT_PG_LAYOUT_INFO_SIZE]: 25, [DEFAULT_PG_LAYOUT_MARGINS]: 20, [DEFAULT_PG_LAYOUT_SPACING]: 24, [DEFAULT_PG_IMAGE_ALIGNMENT]: 2, [DEFAULT_PG_LAYOUT_SIDES_PADDING]: 24 });
const PG_LIST_SETTINGS_MY_POSTS = {
    [DEFAULT_PG_LAYOUT_SPACING]: 20,
    [DEFAULT_PG_LAYOUT_ITEM_SIZE]: 280,
    [DEFAULT_PG_LAYOUT_CARDS_ROW_TYPE]: PG_LAYOUT_CARDS_ROW_TYPE_OPTIONS.FIT_TO_SCREEN,
    [DEFAULT_PG_LAYOUT_POSTS_PER_ROW]: 1,
    [DEFAULT_PG_LAYOUT_INFO_SIZE]: 60,
    [DEFAULT_PG_LAYOUT_SIDES_PADDING]: 12,
    [DEFAULT_PG_LAYOUT_MARGINS]: 0,
    [DEFAULT_PG_LAYOUT_IMAGE_RATIO]: 3,
    [DEFAULT_PG_IMAGE_PROPORTIONS]: 32,
    [DEFAULT_PG_IMAGE_RESIZING_MODE]: PG_LAYOUT_IMAGE_RESIZING_MODE_OPTIONS.PROPORTIONAL,
    [DEFAULT_PG_IMAGE_ALIGNMENT]: 2,
    [DEFAULT_PG_LAYOUT_IMAGE_CROP_TYPE]: 0,
    [DEFAULT_PG_LAYOUT_TITLE_LINE_COUNT]: 3,
};
const PG_SLIDER_SETTINGS = {
    [MIN_PG_LAYOUT_INFO_SIZE]: 0,
    [MIN_PG_LAYOUT_SIDES_PADDING]: 0,
    [MIN_PG_LAYOUT_MARGINS]: 0,
    [MIN_PG_LAYOUT_TITLE_LINE_COUNT]: 1,
    [MIN_PG_LAYOUT_DESCRIPTION_LINE_COUNT]: 1,
    [MAX_PG_LAYOUT_INFO_SIZE]: 700,
    [MAX_PG_LAYOUT_SIDES_PADDING]: 48,
    [MAX_PG_LAYOUT_MARGINS]: 100,
    [MAX_PG_LAYOUT_TITLE_LINE_COUNT]: 6,
    [MAX_PG_LAYOUT_DESCRIPTION_LINE_COUNT]: 8,
    [DEFAULT_PG_LAYOUT_INFO_SIZE]: 230,
    [DEFAULT_PG_LAYOUT_INFO_SIZE_TYPE]: PG_LAYOUT_INFO_SIZE_TYPE_OPTIONS.MANUAL,
    [DEFAULT_PG_LAYOUT_SIDES_PADDING]: 24,
    [DEFAULT_PG_LAYOUT_MARGINS]: 0,
    [DEFAULT_PG_LAYOUT_IMAGE_RATIO]: 1,
    [DEFAULT_PG_LAYOUT_IMAGE_CROP_TYPE]: 0,
    [DEFAULT_PG_LAYOUT_TITLE_LINE_COUNT]: 3,
    [DEFAULT_PG_LAYOUT_DESCRIPTION_LINE_COUNT]: 3,
    [DEFAULT_PG_LAYOUT_MARGINS_MOBILE]: 0,
    [DEFAULT_PG_LAYOUT_IMAGE_RATIO_MOBILE]: 2,
};
const LAYOUT_SETTINGS = {
    [LAYOUT_PG_TEXT_ON_IMAGE_SMALL]: {
        [SECTION_HOMEPAGE]: PG_TEXT_ON_IMAGE_SMALL_SETTINGS,
        [SECTION_CATEGORY]: PG_TEXT_ON_IMAGE_SMALL_SETTINGS,
        [SECTION_POST_LIST]: PG_TEXT_ON_IMAGE_SMALL_SETTINGS,
        [SECTION_RELATED_POSTS]: PG_TEXT_ON_IMAGE_SMALL_SETTINGS,
        [SECTION_MY_POSTS]: PG_TEXT_ON_IMAGE_SMALL_SETTINGS,
    },
    [LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM]: {
        [SECTION_HOMEPAGE]: PG_TEXT_ON_IMAGE_MEDIUM_SETTINGS,
        [SECTION_CATEGORY]: PG_TEXT_ON_IMAGE_MEDIUM_SETTINGS,
        [SECTION_POST_LIST]: PG_TEXT_ON_IMAGE_MEDIUM_SETTINGS,
        [SECTION_RELATED_POSTS]: PG_TEXT_ON_IMAGE_MEDIUM_SETTINGS,
        [SECTION_MY_POSTS]: PG_TEXT_ON_IMAGE_MEDIUM_SETTINGS,
    },
    [LAYOUT_PG_TEXT_ON_IMAGE_LARGE]: {
        [SECTION_HOMEPAGE]: PG_TEXT_ON_IMAGE_LARGE_SETTINGS,
        [SECTION_CATEGORY]: PG_TEXT_ON_IMAGE_LARGE_SETTINGS,
        [SECTION_POST_LIST]: PG_TEXT_ON_IMAGE_LARGE_SETTINGS,
        [SECTION_RELATED_POSTS]: PG_TEXT_ON_IMAGE_LARGE_SETTINGS,
        [SECTION_MY_POSTS]: PG_TEXT_ON_IMAGE_LARGE_SETTINGS,
    },
    [LAYOUT_PG_CARD_MEDIUM]: {
        [SECTION_HOMEPAGE]: PG_CARD_MEDIUM_SETTINGS,
        [SECTION_CATEGORY]: PG_CARD_MEDIUM_SETTINGS,
        [SECTION_POST_LIST]: PG_CARD_MEDIUM_SETTINGS,
        [SECTION_RELATED_POSTS]: PG_CARD_MEDIUM_SETTINGS,
        [SECTION_MY_POSTS]: PG_CARD_MEDIUM_SETTINGS,
    },
    [LAYOUT_PG_SIDE_BY_SIDE]: {
        [SECTION_HOMEPAGE]: PG_SIDE_BY_SIDE_SETTINGS,
        [SECTION_CATEGORY]: PG_SIDE_BY_SIDE_SETTINGS,
        [SECTION_POST_LIST]: PG_SIDE_BY_SIDE_SETTINGS,
        [SECTION_RELATED_POSTS]: PG_SIDE_BY_SIDE_RELATED_POSTS_SETTINGS,
        [SECTION_MY_POSTS]: PG_SIDE_BY_SIDE_MY_POSTS_SETTINGS,
    },
    [LAYOUT_PG_SIDE_BY_SIDE_RIGHT]: {
        [SECTION_HOMEPAGE]: PG_SIDE_BY_SIDE_RIGHT_SETTINGS,
        [SECTION_CATEGORY]: PG_SIDE_BY_SIDE_RIGHT_SETTINGS,
        [SECTION_POST_LIST]: PG_SIDE_BY_SIDE_RIGHT_SETTINGS,
        [SECTION_RELATED_POSTS]: PG_SIDE_BY_SIDE_RIGHT_SETTINGS,
        [SECTION_MY_POSTS]: PG_SIDE_BY_SIDE_MY_POSTS_SETTINGS,
    },
    [LAYOUT_PG_GRID]: {
        [SECTION_HOMEPAGE]: PG_GRID_SETTINGS,
        [SECTION_CATEGORY]: PG_GRID_SETTINGS,
        [SECTION_POST_LIST]: PG_GRID_SETTINGS,
        [SECTION_RELATED_POSTS]: PG_GRID_RELATED_POSTS_SETTINGS,
        [SECTION_MY_POSTS]: PG_GRID_SETTINGS,
    },
    [LAYOUT_PG_GRID_INTERMEDIATE]: {
        [SECTION_HOMEPAGE]: PG_GRID_INTERMEDIATE_SETTINGS,
        [SECTION_CATEGORY]: PG_GRID_INTERMEDIATE_SETTINGS,
        [SECTION_POST_LIST]: PG_GRID_INTERMEDIATE_SETTINGS,
        [SECTION_RELATED_POSTS]: PG_GRID_INTERMEDIATE_SETTINGS,
        [SECTION_MY_POSTS]: PG_GRID_INTERMEDIATE_SETTINGS,
    },
    [LAYOUT_PG_GRID_LARGE]: {
        [SECTION_HOMEPAGE]: PG_GRID_LARGE_SETTINGS,
        [SECTION_CATEGORY]: PG_GRID_LARGE_SETTINGS,
        [SECTION_POST_LIST]: PG_GRID_LARGE_SETTINGS,
        [SECTION_RELATED_POSTS]: PG_GRID_LARGE_SETTINGS,
        [SECTION_MY_POSTS]: PG_GRID_LARGE_SETTINGS,
    },
    [LAYOUT_PG_ONE_COLUMN]: {
        [SECTION_HOMEPAGE]: PG_ONE_COLUMN_SETTINGS,
        [SECTION_CATEGORY]: PG_ONE_COLUMN_SETTINGS,
        [SECTION_POST_LIST]: PG_ONE_COLUMN_SETTINGS,
        [SECTION_RELATED_POSTS]: PG_ONE_COLUMN_SETTINGS,
        [SECTION_MY_POSTS]: PG_ONE_COLUMN_SETTINGS,
    },
    [LAYOUT_SLIDER]: {
        [SECTION_HOMEPAGE]: PG_SLIDER_SETTINGS,
        [SECTION_CATEGORY]: PG_SLIDER_SETTINGS,
        [SECTION_POST_LIST]: PG_SLIDER_SETTINGS,
        [SECTION_RELATED_POSTS]: PG_SLIDER_SETTINGS,
        [SECTION_MY_POSTS]: PG_SLIDER_SETTINGS,
    },
    [LAYOUT_LIST]: {
        [SECTION_HOMEPAGE]: PG_LIST_SETTINGS,
        [SECTION_CATEGORY]: PG_LIST_SETTINGS,
        [SECTION_POST_LIST]: PG_LIST_SETTINGS,
        [SECTION_RELATED_POSTS]: PG_LIST_SETTINGS,
        [SECTION_MY_POSTS]: PG_LIST_SETTINGS_MY_POSTS,
    },
    [LAYOUT_LIST_MEDIUM]: {
        [SECTION_HOMEPAGE]: PG_LIST_MEDIUM_SETTINGS,
        [SECTION_CATEGORY]: PG_LIST_MEDIUM_SETTINGS,
        [SECTION_POST_LIST]: PG_LIST_MEDIUM_SETTINGS,
        [SECTION_RELATED_POSTS]: PG_LIST_MEDIUM_SETTINGS,
        [SECTION_MY_POSTS]: PG_LIST_MEDIUM_SETTINGS,
    },
    [LAYOUT_LIST_LARGE]: {
        [SECTION_HOMEPAGE]: PG_LIST_LARGE_SETTINGS,
        [SECTION_CATEGORY]: PG_LIST_LARGE_SETTINGS,
        [SECTION_POST_LIST]: PG_LIST_LARGE_SETTINGS,
        [SECTION_RELATED_POSTS]: PG_LIST_LARGE_SETTINGS,
        [SECTION_MY_POSTS]: PG_LIST_LARGE_SETTINGS,
    },
};
export const getPGLayoutSettingsConstant = (layoutType, settingsKey, section = SECTION_HOMEPAGE) => get(LAYOUT_SETTINGS, `${layoutType}.${section}.${settingsKey}`);
//# sourceMappingURL=pro-gallery.js.map